export default class CollectionError extends Error {
    connectorError;
    /* istanbul ignore next */
    constructor(message, connectorError) {
        super(message);
        this.connectorError = connectorError;
    }
}
//# sourceMappingURL=collectionError.js.map